import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useReviewersLiveUpdates} from '../../../hooks/use-reviewers-live-updates'
import {pullRequestsLayoutRoute} from '../../../routes/layout-route'
import {useReviewRequestsQuery} from '../data/route-queries'
import type {ReviewRequestsData} from '../../../page-data/payloads/review-requests'

export function ReviewersLoader({children}: {children: (reviewers: ReviewRequestsData) => React.ReactNode}) {
  const {data: reviewers} = useReviewRequestsQuery()
  const {data: layoutData} = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')

  useReviewersLiveUpdates(layoutData.aliveChannels)

  return <>{children(reviewers)}</>
}
